var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "schedule-email-dialog",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__("email.ScheduleEmailDialog.title"),
        primaryAction: _vm.primaryAction,
        secondaryActions: _vm.secondaryActions
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _vm.isInvalidDateTime
            ? _c("CompassAlert", {
                attrs: {
                  type: "error",
                  description: _vm.$t.__("email.ScheduleEmailDialog.error"),
                  showClose: false
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t.__("email.ScheduleEmailDialog.description")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "schedule-email-dialog__form" },
            [
              _c(
                "CompassFormItem",
                { attrs: { label: "Date" } },
                [
                  _c("CompassDatePicker", {
                    staticClass: "schedule-email-dialog__date-input",
                    attrs: {
                      formatDateDisplayed: _vm.formatDateDisplayed,
                      datePickerClass: "schedule-email-dialog__datepicker",
                      calendarOptions: {
                        lang: _vm.uiLang,
                        disablePast: true
                      }
                    },
                    on: { "update:value": _vm.handleUpdateDate },
                    model: {
                      value: _vm.scheduleDate,
                      callback: function($$v) {
                        _vm.scheduleDate = $$v
                      },
                      expression: "scheduleDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassFormItem",
                { attrs: { label: "Heure" } },
                [
                  _c("CompassTimePicker", {
                    key: "schedule-time-" + _vm.scheduleDate,
                    staticClass: "schedule-email-dialog__timepicker",
                    attrs: {
                      hourFormat: _vm.hourformat,
                      min: _vm.minTime,
                      autoScroll: ""
                    },
                    on: { "update:value": _vm.handleTimeUpdate },
                    model: {
                      value: _vm.scheduleTime,
                      callback: function($$v) {
                        _vm.scheduleTime = $$v
                      },
                      expression: "scheduleTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }